/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { BreakpointObserver } from '@angular/cdk/layout';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';

export const BREAKPOINTS = new InjectionToken<Hash<string>>('Breakpoints');

@Injectable()
export class BreakpointManager {
  constructor(private observer: BreakpointObserver,
              @Inject(BREAKPOINTS) private breakpoints: Hash<string>) {
  }

  isActive(bp: string): boolean {
    return this.observer.isMatched(this.getMediaQuery(bp));
  }

  observeMatches(bp: string): Observable<boolean> {
    return this.observer.observe(this.getMediaQuery(bp)).pipe(map$(({ matches }) => matches));
  }

  private getMediaQuery(bp: string): string {
    return this.breakpoints[bp];
  }
}
